import BaseService from "../BaseService";
import _ from "lodash";

class SignupService extends BaseService {
    signupWithPhone = async (info) => {
        var data = await this._api.post("signup/withphone", info);
        return data;
    }
    createWithOTP = async (info) => {
        var data = await this._api.post("signup/createwithotp", info);
        return data;
    }


    checkPhone = async (phone) => {
        var data = await this._api.post("signup/checkphone", { phone });
        return data;
    }

    createShop = async (info) => {
        var data = await this._api.post("signup/createshop", info);
        return data;
    }
    createShopWithOTP = async (info) => {
        var data = await this._api.post("signup/createshopwithotp", info);
        return data;
    }








}
export default SignupService;
